import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Layout from "../../Component/layout/main-layout";
import GlobalLayout from "../../Component/layout/global-layout";
import layoutBgImg from "../../Images/layout/others.jpg";

import { Context } from "../../Store/context";
import { DeleteAccount } from "../../api/Queries/delete";

const DeleteAccountPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { showError, showSuccess } = useContext(Context);

    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const [form, setForm] = useState({
        password: "",
    });

    const [errors, setErrors] = useState({});

    const change = (key, value) => {
        setForm((prev) => ({
            ...prev,
            [key]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [key]: "",
        }));
    };

    const validate = () => {
        const nextErrors = {};

        if (!form.password) {
            nextErrors.password = t("required_password") || "Password is required";
        }

        return nextErrors;
    };

    const getErrorMessage = (error) => {
        const data = error?.data || error?.response?.data;

        if (typeof data === "string") return data;
        if (data?.detail) return data.detail;
        if (data?.message) return data.message;

        const firstKey =
            data && typeof data === "object" ? Object.keys(data)[0] : null;
        if (firstKey) {
            const value = data[firstKey];
            if (Array.isArray(value)) return String(value[0]);
            if (typeof value === "string") return value;
        }
        return error?.message || t("not_success");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validation = validate();
        setErrors(validation);
        if (Object.keys(validation).length > 0) return;
        setIsLoading(true);
        try {
            const res = await DeleteAccount({
                password: form.password,
            });
            showSuccess(res?.detail || "Account deleted successfully.");
            localStorage.removeItem("token");
            localStorage.removeItem("refresh");
            localStorage.removeItem("user");
            navigate("/");
        } catch (error) {
            showError(getErrorMessage(error));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <GlobalLayout
            title={`${t("delete_account") || "Delete Account"} - ${t(
                "supreme_court"
            )} ${t("turkmenistan")}`}
            keywords=""
        >
            <div className="mb-20">
                <Layout
                    title={t("delete_account") || "Delete Account"}
                    layoutBgImg={layoutBgImg}
                />

                <div className="flex justify-center w-full">
                    <div
                        className="bg-white dark:bg-dark-box
                       xl:w-[40%] w-[90%]
                       p-4 xl:p-8 mt-8 rounded"
                    >
                        <h1
                            className="text-center font-bold
                         text-3xl xl:text-4xl
                         dark:text-white"
                        >
                            {t("delete_account") || "Delete Account"}
                        </h1>

                        <div className="mt-5 mb-6  border border-red rounded p-4">
                            <p className="text-red text-sm font-semibold">
                                ⚠ {t("warning") || "Warning"}
                            </p>

                            <p className="text-sm text-text mt-2">
                                {t("delete_account_warning") ||
                                    "Deleting your account is permanent. All your information will be removed and cannot be recovered."}
                            </p>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="relative">
                                <label className="text-sm dark:text-dark-text">
                                    {t("password")}
                                </label>

                                <div
                                    className={`flex items-center border bg-secondary mt-1 mb-1 rounded
                                                dark:bg-dark-box dark:border-dark-border
                                                ${errors.password ? "border-red" : "border-border"
                                        }`}
                                >
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        value={form.password}
                                        onChange={(e) =>
                                            change("password", e.target.value)
                                        }
                                        placeholder="******"
                                        className="w-full px-4 py-2 dark:bg-dark-box dark:border-dark-border
                                                 bg-transparent focus:outline-none dark:text-dark-text"
                                    />

                                    <button
                                        type="button"
                                        onClick={() =>
                                            setShowPassword((prev) => !prev)
                                        }
                                        className="px-3 text-sm text-primary dark:text-white"
                                    >
                                        {showPassword
                                            ? t("hide") || "Hide"
                                            : t("show") || "Show"}
                                    </button>
                                </div>

                                {errors.password && (
                                    <p className="text-red text-xs mb-2">
                                        {errors.password}
                                    </p>
                                )}
                            </div>

                            <button
                                type="submit"
                                disabled={isLoading}
                                className={`relative w-full mt-6 bg-primary hover:opacity-70
                                  text-white py-2 rounded flex justify-center items-center min-h-[42px]                  
                                  ${isLoading
                                        ? "opacity-70 cursor-not-allowed"
                                        : ""
                                    }`}
                            >
                                <span className={isLoading ? "invisible" : "visible"}>
                                    {t("delete_account") || "Delete Account"}
                                </span>

                                {isLoading && (
                                    <span
                                        className="absolute w-4 h-4 border-2 border-white
                                                   border-t-transparent rounded-full animate-spin"
                                    />
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </GlobalLayout>
    );
};

export default DeleteAccountPage;